module.exports = __webpack_public_path__ + "static/media/Carol Hair Moore Character.f400a1b2.png";